
























































import ItemCol from './ItemCol.vue';
import BlockHeader from './BlockHeader.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'studentReferrer',
  components: {
    ItemCol,
    BlockHeader
  }
})
export default class extends Vue {
  @Prop() public studentReferences!: any;
  @Prop() public num!: number;

  get studentReference() {
    if (this.studentReferences) {
      return this.studentReferences[this.num]
    }
    return null;
  }
}
